import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Paper, Button, IconButton, TextField, Box, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getIcon } from './../../utils/IconHandler';
import { permissionOptions } from './../../utils/Enums';
import TableRefreshButton from '../../components/TableRefreshButton/TableRefreshButton';

const SuppliersTable = ({ 
  suppliers = [], 
  paginationModel, 
  onPaginationModelChange, 
  sortModel,
  onSortModelChange,
  filterModel,
  onFilterModelChange,
  searchTerm, 
  onSearchChange, 
  totalRows, 
  onRefresh,
  onAdd, 
  onEdit, 
  onView, 
  onDelete, 
  loading 
}) => { 
  const { t } = useTranslation();
  
  const userPermissions = JSON.parse(localStorage.getItem('permissions')) || [];
  const hasPermission = (permissionId) => userPermissions.includes(permissionId);

  const columns = [
    { field: 'name', headerName: t('business_name'), flex: 1.5 },
    { field: 'rut', headerName: t('RUT'), flex: 1, align: 'center', headerAlign: 'center' },
    { field: 'sellerName', headerName: t('seller_name'), flex: 1, align: 'center', headerAlign: 'center' },
    { field: 'sellerPhone', headerName: t('seller_phone'), flex: 1.5, align: 'center', headerAlign: 'center' },
    { field: 'businessPhone', headerName: t('business_phone'), flex: 1.5, align: 'center', headerAlign: 'center' },
    { 
      field: 'actions', 
      headerName: t('actions'), 
      flex: 1.3, 
      sortable: false, 
      align: 'right',
      headerAlign: 'right',
      renderCell: (params) => (
        <>
          <IconButton onClick={() => onView(params.row)}>
            {getIcon('eye')}
          </IconButton>
          {hasPermission(permissionOptions.find(p => p.label === 'UPDATE_SUPPLIERS').id) && (
            <IconButton onClick={() => onEdit(params.row)}>
              {getIcon('settings')}
            </IconButton>
          )}
          {hasPermission(permissionOptions.find(p => p.label === 'DELETE_SUPPLIERS').id) && (
            <IconButton onClick={() => onDelete(params.row)}>
              {getIcon('trash')}
            </IconButton>
          )}
        </>
      )
    }
  ];

  return (
    <>
      <Paper sx={{ padding: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <TextField
            label={t('search')}
            placeholder={t('search_by_name_rut')}
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            sx={{ width: '300px' }}
          />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <TableRefreshButton loading={loading} onClick={onRefresh} />
            {hasPermission(permissionOptions.find(p => p.label === 'CREATE_SUPPLIERS').id) && (
              <Button variant="outlined" startIcon={getIcon('add')} onClick={onAdd}>
                {t('add_supplier')}
              </Button>
            )}
          </Box>
        </Box>
        
        <DataGrid
          loading={loading}
          rows={suppliers}
          columns={columns}
          paginationModel={paginationModel}
          onPaginationModelChange={onPaginationModelChange}
          sortModel={sortModel}
          onSortModelChange={onSortModelChange}
          sortingMode="server"
          filterModel={filterModel}
          onFilterModelChange={onFilterModelChange}
          filterMode="server"
          pageSizeOptions={[10, 25, 50]}
          paginationMode="server"
          rowCount={totalRows}
        />
      </Paper>
    </>
  );
};

export default SuppliersTable;
